import { render, staticRenderFns } from "./WorkflowRequestDesktop.vue?vue&type=template&id=3470ed30&scoped=true"
import script from "./WorkflowRequestDesktop.vue?vue&type=script&lang=js"
export * from "./WorkflowRequestDesktop.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRequestDesktop.vue?vue&type=style&index=0&id=3470ed30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3470ed30",
  null
  
)

export default component.exports